import React, { useEffect, useState } from 'react';
import { Card, Table, Button, Form, Badge, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import { CME_ADMIN_API } from '../../../../utils/apiUrl';
import { Get, Post } from '../../../../utils/httpProvider';
import { messageToast, objectShowNumber, status200, objectTrangThaiCME, trangThaiCMEValue } from '../../../../utils/define';
import { formatDateTimeWithoutHour, createUrlWithParam } from '../../../../utils/helper';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';
import CMEHoSoDetailModal from '../caNhan/CMEHoSoDetailModal';
import UserInfoCell from './UserInfoCell';
import AsyncSelect from 'react-select/async';
import { ACCOUNT_AUTHINFO_API } from '../../../../utils/apiUrl';

const CMEDuyetHoSo = () => {
    const queryClient = useQueryClient();
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    // Parse URL search params
    const paramUrl = new URLSearchParams(location.search);
    const initialPage = paramUrl.get('page') != null ? parseInt(paramUrl.get('page'), 10) : 1;
    const initialPageSize = paramUrl.get('size') != null ? parseInt(paramUrl.get('size'), 10) : 20;
    const initialKeyword = paramUrl.get('search') != null ? paramUrl.get('search') : '';
    const initialStatus = paramUrl.get('status') != null ? parseInt(paramUrl.get('status'), 10) : trangThaiCMEValue.all;
    const initialCategory = paramUrl.get('category') != null ? paramUrl.get('category') : '';
    const initialUserId = paramUrl.get('userId') != null ? paramUrl.get('userId') : null;

    const [page, setPage] = useState(initialPage);
    const [pageSize, setPageSize] = useState(initialPageSize);
    const [trangThai, setTrangThai] = useState(initialStatus);
    const [keyword, setKeyword] = useState(initialKeyword);
    const [danhMucId, setDanhMucId] = useState(initialCategory);
    const [selectedUser, setSelectedUser] = useState(initialUserId ? { value: initialUserId } : null);

    // Sync state with URL when URL changes
    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        const p = params.get('page') != null ? parseInt(params.get('page'), 10) : 1;
        const s = params.get('size') != null ? parseInt(params.get('size'), 10) : 20;
        const kw = params.get('search') != null ? params.get('search') : '';
        const st = params.get('status') != null ? parseInt(params.get('status'), 10) : trangThaiCMEValue.all;
        const cat = params.get('category') != null ? params.get('category') : '';
        const uid = params.get('userId');

        if (p !== page) setPage(p);
        if (s !== pageSize) setPageSize(s);
        if (kw !== keyword) setKeyword(kw);
        if (st !== trangThai) setTrangThai(st);
        if (cat !== danhMucId) setDanhMucId(cat);
        if (uid !== (selectedUser?.value || null)) {
            setSelectedUser(uid ? { value: uid } : null);
        }
    }, [location.search]);

    // Helper to remove null, undefined, or empty string parameters
    const cleanParams = (params) => {
        const result = {};
        Object.entries(params).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                result[key] = value;
            }
        });
        return result;
    };

    const replaceHistory = (Page, Size, Search, Status, Category, UserId) => {
        const rawParams = {
            page: Page,
            size: Size,
            search: Search,
            status: Status !== trangThaiCMEValue.all ? Status : null,
            category: Category || null,
            userId: UserId || null,
        };
        history.replace(
            createUrlWithParam(location.pathname, cleanParams(rawParams))
        );
    };

    // Ensure default params exist in URL on mount
    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('page') == null || params.get('size') == null || params.get('search') == null) {
            replaceHistory(page, pageSize, keyword, trangThai, danhMucId, selectedUser?.value);
        }
    }, []);

    const changePage = (number) => {
        replaceHistory(number, pageSize, keyword, trangThai, danhMucId, selectedUser?.value);
    };

    const onChangeShowNumber = (e) => {
        const val = Number(e.target.value);
        replaceHistory(1, val, keyword, trangThai, danhMucId, selectedUser?.value); // reset page to 1 when changing size
    };

    const onChangeKeyword = (e) => {
        const val = e.target.value;
        replaceHistory(1, pageSize, val, trangThai, danhMucId, selectedUser?.value); // reset page to 1 when searching
    };

    const [openApproveModal, setOpenApproveModal] = useState(false);
    const [openRejectModal, setOpenRejectModal] = useState(false);
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [detailData, setDetailData] = useState(null);
    const [lyDoTuChoi, setLyDoTuChoi] = useState('');

    // Logic tìm kiếm cán bộ cho Autocomplete
    const loadOptions = async (inputValue) => {
        if (!inputValue || inputValue.length < 2) return [];
        try {
            const res = await Get(ACCOUNT_AUTHINFO_API.GET_PAGING, null, {
                Keyword: inputValue,
                PageIndex: 1,
                PageSize: 20
            });
            const list = res?.data || res?.Data || res?.$values || [];
            return list.map(u => ({
                value: u.accountId || u.AccountId || u.id,
                label: [u.lastName || u.LastName, u.middleName || u.MiddleName, u.firstName || u.FirstName].filter(Boolean).join(' ') || 'Chưa cập nhật',
                firstName: u.firstName || u.FirstName,
                middleName: u.middleName || u.MiddleName,
                lastName: u.lastName || u.LastName,
                userName: u.account?.username || u.Account?.UserName
            }));
        } catch (error) {
            console.error("Error searching users:", error);
            return [];
        }
    };

    // Tận dụng UserInfoCell để hiển thị Tên + CCCD chuẩn xác
    const CustomOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return (
            <div ref={innerRef} {...innerProps} style={{ padding: '8px 12px', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
                <UserInfoCell
                    userId={data.value}
                    firstName={data.firstName}
                    middleName={data.middleName}
                    lastName={data.lastName}
                    userName={data.userName}
                />
            </div>
        );
    };

    const CustomSingleValue = (props) => {
        const { data } = props;
        return (
            <div className="py-1">
                <UserInfoCell
                    userId={data.value}
                    firstName={data.firstName}
                    middleName={data.middleName}
                    lastName={data.lastName}
                    userName={data.userName}
                />
            </div>
        );
    };

    // Fetch Categories for Filter
    const { data: categoriesData } = useQuery(
        ['cmeCategoriesForFilter'],
        () => Get(CME_ADMIN_API.GET_CATEGORIES)
    );
    const categories = categoriesData?.data?.$values || categoriesData?.data || categoriesData?.$values || categoriesData || [];

    const { isLoading, isError, data, refetch } = useQuery(
        ['allCMEHoSoData', keyword, page, pageSize, trangThai, danhMucId, selectedUser?.value],
        () => {
            const model = {
                Keyword: keyword || '',
                PageIndex: page,
                PageSize: pageSize,
                TrangThai: trangThai !== trangThaiCMEValue.all ? trangThai : null,
                DanhMucId: danhMucId || null,
                UserId: selectedUser?.value || null
            };
            return Get(CME_ADMIN_API.GET_ALL_HO_SO, null, cleanParams(model));
        },
        { keepPreviousData: true }
    );

    const approveMutation = useMutation((payload) => Post(CME_ADMIN_API.DUYET_HO_SO, null, payload));

    const handleApprove = (item) => {
        setSelectedItem(item);
        setOpenApproveModal(true);
    };

    const handleReject = (item) => {
        setSelectedItem(item);
        setLyDoTuChoi('');
        setOpenRejectModal(true);
    };

    const handleViewDetail = (item) => {
        setDetailData(item);
        setOpenDetailModal(true);
    };

    const confirmApprove = () => {
        const payload = {
            id: selectedItem.id,
            trangThai: trangThaiCMEValue.daDuyet
        };

        approveMutation.mutate(payload, {
            onSuccess: (res) => {
                if (res.status === status200 || res === true) {
                    toast.success("Đã phê duyệt hồ sơ thành công");
                    queryClient.invalidateQueries(['allCMEHoSoData']);
                } else {
                    toast.error(res?.message || "Lỗi khi phê duyệt");
                }
            }
        });
        setOpenApproveModal(false);
    };

    const confirmReject = () => {
        if (!lyDoTuChoi.trim()) {
            toast.error("Vui lòng nhập lý do từ chối");
            return;
        }

        const payload = {
            id: selectedItem.id,
            trangThai: trangThaiCMEValue.tuChoi,
            lyDoTuChoi: lyDoTuChoi
        };

        approveMutation.mutate(payload, {
            onSuccess: (res) => {
                if (res.status === status200 || res === true) {
                    toast.success("Đã từ chối hồ sơ");
                    queryClient.invalidateQueries(['allCMEHoSoData']);
                } else {
                    toast.error(res?.message || "Lỗi khi từ chối");
                }
            }
        });
        setOpenRejectModal(false);
    };

    const items = data?.data?.$values || data?.data || data?.Data?.$values || data?.Data || [];
    const totalRecords = data?.totalRecords || data?.TotalRecords || 0;

    const getStatusBadge = (status) => {
        const found = objectTrangThaiCME.find(x => x.value === status);
        return found ? <Badge variant={found.color}>{found.label}</Badge> : <Badge variant="secondary">N/A</Badge>;
    };

    return (
        <div className="container-fluid">
            <Card className="shadow-sm">
                <Card.Header className="bg-white py-3">
                    <h5 className="mb-0 text-primary"><i className="fas fa-check-double mr-2"></i>Phê duyệt hồ sơ CME</h5>
                </Card.Header>
                <Card.Body>
                    {/* Bộ lọc nâng cao */}
                    <div className="row mb-4 align-items-end bg-light p-3 mx-0 rounded border shadow-sm">
                        <div className="col-md-2">
                            <Form.Label className="small font-weight-bold">Từ khóa</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Nội dung..."
                                value={keyword}
                                onChange={onChangeKeyword}
                                className="border-0 shadow-sm"
                            />
                        </div>
                        <div className="col-md-3">
                            <Form.Label className="small font-weight-bold">Cán bộ nộp</Form.Label>
                            <AsyncSelect
                                isClearable
                                cacheOptions
                                loadOptions={loadOptions}
                                value={selectedUser}
                                onChange={(opt) => {
                                    replaceHistory(1, pageSize, keyword, trangThai, danhMucId, opt?.value || null);
                                }}
                                placeholder="Tên hoặc CCCD..."
                                className="basic-single"
                                classNamePrefix="select"
                                noOptionsMessage={({ inputValue }) =>
                                    !inputValue ? "Nhập tên hoặc CCCD..." : "Không tìm thấy cán bộ"
                                }
                                components={{
                                    Option: CustomOption,
                                    SingleValue: CustomSingleValue
                                }}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '38px',
                                        borderRadius: '4px',
                                        border: 'none',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        padding: '0 8px'
                                    })
                                }}
                            />
                        </div>
                        <div className="col-md-2">
                            <Form.Label className="small font-weight-bold">Trạng thái</Form.Label>
                            <Form.Control as="select" value={trangThai} onChange={(e) => {
                                replaceHistory(1, pageSize, keyword, Number(e.target.value), danhMucId, selectedUser?.value);
                            }} className="border-0 shadow-sm">
                                <option value={trangThaiCMEValue.all}>Tất cả</option>
                                {objectTrangThaiCME.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div className="col-md-3">
                            <Form.Label className="small font-weight-bold">Danh mục CME</Form.Label>
                            <Form.Control as="select" value={danhMucId} onChange={(e) => {
                                replaceHistory(1, pageSize, keyword, trangThai, e.target.value, selectedUser?.value);
                            }} className="border-0 shadow-sm">
                                <option value="">Tất cả danh mục</option>
                                {categories.map(cat => (
                                    <option key={cat.id} value={cat.id}>{cat.tenDanhMuc}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div className="col-md-2">
                            <Button
                                variant="white"
                                className="w-100 shadow-sm border font-weight-bold"
                                onClick={() => {
                                    replaceHistory(1, pageSize, '', trangThaiCMEValue.all, '', null);
                                }}
                            >
                                <i className="fas fa-sync-alt mr-1"></i>Reset
                            </Button>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead className="thead-light">
                                <tr>
                                    <th>STT</th>
                                    <th>Cán bộ nộp</th>
                                    <th>Nội dung hoạt động</th>
                                    <th>Danh mục/Tiểu mục</th>
                                    <th>Vai trò</th>
                                    <th>Minh chứng</th>
                                    <th>Số giờ</th>
                                    <th>Thời gian</th>
                                    <th>Trạng thái</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan={10} className="text-center">Đang tải dữ liệu...</td></tr>
                                ) : items.length === 0 ? (
                                    <tr><td colSpan={10} className="text-center">Không tìm thấy hồ sơ nào</td></tr>
                                ) : (
                                    items.map((item, index) => (
                                        <tr key={item.id}>
                                            <td className="text-center">{(page - 1) * pageSize + index + 1}</td>
                                            <td>
                                                <UserInfoCell userId={item.userId} />
                                            </td>
                                            <td>
                                                <div className="font-weight-bold text-dark cursor-pointer" onClick={() => handleViewDetail(item)}>
                                                    {item.noiDung}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column">
                                                    <small className="text-muted text-uppercase font-weight-bold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>
                                                        {item.tenDanhMuc}
                                                    </small>
                                                    <div className="text-dark" style={{ lineHeight: '1.4', fontSize: '0.85rem', fontWeight: '500' }}>
                                                        {item.tenTieuMuc}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{item.vaiTro || 'N/A'}</td>
                                            <td className="text-center">
                                                {(item.dinhKemFiles?.$values || item.dinhKemFiles || item.DinhKemFiles?.$values || item.DinhKemFiles || []).length > 0 ? (
                                                    <Badge variant="info" pill style={{ cursor: 'pointer' }} onClick={() => handleViewDetail(item)}>
                                                        <i className="fas fa-paperclip mr-1"></i>
                                                        {(item.dinhKemFiles?.$values || item.dinhKemFiles || item.DinhKemFiles?.$values || item.DinhKemFiles || []).length} file
                                                    </Badge>
                                                ) : (
                                                    <small className="text-muted">Không có</small>
                                                )}
                                            </td>
                                            <td className="text-center font-weight-bold text-primary">{item.soGioTinChi}h</td>
                                            <td>
                                                <div className="small">
                                                    <div><i className="far fa-calendar-alt mr-1"></i>{formatDateTimeWithoutHour(item.tuNgay)}</div>
                                                    <div><i className="far fa-calendar-check mr-1"></i>{formatDateTimeWithoutHour(item.denNgay)}</div>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                {getStatusBadge(item.trangThai)}
                                                {item.trangThai === trangThaiCMEValue.tuChoi && item.lyDoTuChoi && (
                                                    <div className="text-danger small mt-1" title={item.lyDoTuChoi}>
                                                        <i className="fas fa-info-circle mr-1"></i> {item.lyDoTuChoi}
                                                    </div>
                                                )}
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <Button
                                                        variant="outline-info"
                                                        size="sm"
                                                        className="mr-1"
                                                        style={{ width: '55px', padding: '2px 0' }}
                                                        onClick={() => handleViewDetail(item)}
                                                        title="Xem chi tiết"
                                                    >
                                                        Chi tiết
                                                    </Button>

                                                    {item.trangThai === trangThaiCMEValue.choDuyet && (
                                                        <>
                                                            <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                className="mr-1"
                                                                style={{ width: '50px', padding: '2px 0' }}
                                                                onClick={() => handleApprove(item)}
                                                                title="Duyệt"
                                                            >
                                                                Duyệt
                                                            </Button>
                                                            <Button
                                                                variant="outline-danger"
                                                                size="sm"
                                                                style={{ width: '75px', padding: '2px 0' }}
                                                                onClick={() => handleReject(item)}
                                                                title="Từ chối"
                                                            >
                                                                Từ chối
                                                            </Button>
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '80px' }}>
                            {objectShowNumber.map(opt => <option key={opt.value} value={opt.value}>{opt.text}</option>)}
                        </Form.Control>
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={pageSize}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={changePage}
                            itemClass="page-item"
                            linkClass="page-link"
                        />
                    </div>
                </Card.Body>
            </Card>

            {/* Modal Phê duyệt */}
            <ConfirmModal
                isOpen={openApproveModal}
                confirmType="success"
                handleAccept={confirmApprove}
                handleCancel={() => setOpenApproveModal(false)}
                title="Xác nhận phê duyệt"
                content={
                    <div>
                        Bạn có chắc chắn muốn phê duyệt hồ sơ của cán bộ:
                        <div className="mt-2 p-2 border rounded bg-light">
                            <UserInfoCell userId={selectedItem?.userId} />
                        </div>
                    </div>
                }
                labelAccept="Phê duyệt"
            />

            {/* Modal Từ chối */}
            <Modal
                show={openRejectModal}
                onHide={() => setOpenRejectModal(false)}
                centered
                backdrop="static"
                keyboard={false}
                style={{ zIndex: '9999' }}
            >
                <Modal.Header closeButton className="bg-danger text-white">
                    <Modal.Title style={{ fontSize: '1.2rem' }}>Từ chối hồ sơ CME</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Lý do từ chối <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Nhập lý do cán bộ cần bổ sung hoặc lý do từ chối..."
                            value={lyDoTuChoi}
                            onChange={(e) => setLyDoTuChoi(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setOpenRejectModal(false)}>Hủy</Button>
                    <Button variant="danger" onClick={confirmReject}>Xác nhận từ chối</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Chi tiết hồ sơ */}
            <CMEHoSoDetailModal
                isOpen={openDetailModal}
                handleClose={() => setOpenDetailModal(false)}
                data={detailData}
            />
        </div>
    );
};

export default CMEDuyetHoSo;
